
export function xslog(...message: any[]) {
    console.log("XingShi", ...message);
}